import React  from "react";
import RegisteredApplicants from "./components/RegisteredApplicants";
import { 
    Users,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";

const Applicants = () => {

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6">
                <SummaryHeader
                    title={"Registered Applicants"}
                    icon={Users}
                    description={"Manage registered applicants"}
                    color={"green"}
                />
                <RegisteredApplicants />
            </div>
        </div>
    );
};

export default Applicants;